import {focusBlock, gInterText} from '../highlight.jsx';
import event, {EVENTS} from '../../lib/event';
import {useTouchInteraction, onClick} from '../utils';
import Audio from '../../lib/audio.js';
import Cartoon from '../avatar-action';
import {toolboxScrollToNode} from "../highlight";
import {selectElement} from "../../lib/utils";
import {BATCH_TIPS_MODE, GUIDE_MODE} from '../../lib/constant';

/**
 * 引导用户点击某个元素
 * @param {string|function} element - 需要点击的元素的element、 element selector 或者是一个方法返回 element dom
 * @param {number} index - 当element为string类型的selector时，表示第几个匹配
 * @param {string} tips - 提示，默认为`请点击${categoryName}`
 * @param {left, top, width, height} args.sourceOffset - 偏移量
 * @param {boolean} args.noModal - 不显示modal
 * @param {boolean} noTips - 不显示tips
 * @param {number} args.zIndex
 * @returns {Promise} 执行成功的 Promise，这个方法不可能失败
 */
export default function clickElement  ({element: _element, index, tips, sourceOffset, noModal, noTips, zIndex}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    if (!tips) {
        tips = "点击高亮处";
    }
    return new Promise(async (resolve, reject) => {
        if (!noTips) {
            if (mode) {
                window.stepsRuntime.insertTips(_index, tips);
                if (mode === BATCH_TIPS_MODE) return;
            } else {
                Audio.tts(tips);
            }
        }

        const onAbort = ()=>{
            reject('Step Abort');
        }
        event.once(EVENTS.STEP_ABORT, onAbort);
        const wrapResolve = arg => {
            event.off(EVENTS.STEP_ABORT, onAbort);
            resolve(arg);
        }
        const wrapReject = arg => {
            event.off(EVENTS.STEP_ABORT, onAbort);
            reject(arg);
        }
        let element = await selectElement(_element, index);

        if (element) {
            focusBlock({source: element, tips, noTips, sourceOffset, reject: wrapReject, noModal, zIndex}, mode, _index);
            const handler = async () => {
                if (typeof(element.className) == 'string' && element.className.includes('action-menu_menu-container_')) { //添加角色等展开菜单等按钮，触摸屏时首次点击只是展开菜单，需要再触发一次点击
                    //element.querySelector("button").click();
                    let modal = await selectElement("[class*=ReactModal__Overlay]");
                    if (!modal) {
                        onClick(element, handler);
                        return;
                    }
                }
                event.emit(EVENTS.CLEAR_COVER);
                wrapResolve(true);
            };
            onClick(element, handler);
        } else {
            if (mode && mode !== GUIDE_MODE) {
                return;
            }
            const msg = `${_element} 未找到`;
            console.error(msg);
            wrapReject(msg);
        }
    });
}
